/* eslint-disable */
import React from "react";
import clsx from "clsx";

import Typograpy from "../Typography";
import { ICurrencyCard } from "./CurrencyCard";

const CurrencyCard: React.FunctionComponent<ICurrencyCard.IProps> = ({
  icon,
  currencyRate,
  cardClassname,
}) => {
  return (
    <div
      className={clsx(
        "bg-white w-[9%] px-4 py-2 rounded-sm flex justify-center items-center gap-2 text-base shadow-[0_3px_0px_0px]",
        cardClassname,
      )}
    >
      <img
        className="w-6 h-6 rounded-full"
        src={require(`../../../assets/Icons/country-flag-icons/${icon}`)}
      />

      <Typograpy tagType="span">INR</Typograpy>
      <Typograpy tagType="span">{currencyRate}</Typograpy>
    </div>
  );
};

export default CurrencyCard;
